module.exports = __webpack_public_path__ + "img/wximg19.6c9cb8ad.png";